class LeadGenModal {
	constructor( dialog ) {
		if ( ! dialog || ! dialog instanceof HTMLDialogElement ) {
			return;
		}

		this.dialog     = dialog;
		this.opened     = false;
		this.main       = this.dialog.querySelector( '.cicero-lead-gen__main' );
		this.closer     = this.dialog.querySelector( '.cicero-lead-gen__closer' );
		this.bodyClass  = 'cicero-lead-gen-active';
		this.outClass   = 'cicero-lead-gen--out';
		this.delay      = 10000; // 10 seconds
		this.duration   = 72 * 60 * 60 * 1000; // 72 hours in milliseconds
		this.storageKey = 'leadGenModalViewed';
		this.lastViewed = parseInt( localStorage.getItem( this.storageKey ), 10 );
		this.preview    = typeof this.dialog.dataset.preview !== 'undefined';

		if ( typeof this.dialog.dataset.preview !== 'undefined' ) {
			this.canShow = true;
			this.delay   = 1000;  // 1 second
		} else if ( ! this.lastViewed || isNaN( this.lastViewed ) ) {
			this.canShow = true;
		} else {
			this.canShow = Date.now() - this.lastViewed > this.duration;
		}

		const animationend = () => {
			if ( this.opened ) {
				// trigger resize event so our responsive iframe can adjust
				document.body.dispatchEvent( new Event( 'resize', { bubbles: true } ) );
			} else {
				document.body.classList.remove( this.bodyClass );
				this.dialog.classList.remove( this.outClass );
				this.dialog.close();
			}
		}

		this.dialog.addEventListener( 'animationend', animationend );
		this.dialog.addEventListener( 'click', (e) => e.target === this.dialog ? this.close() : null, true );
		this.closer.addEventListener( 'click', this.close.bind( this ) );

		if ( this.canShow ) {
			setTimeout( this.open.bind( this ), this.delay );
		}
	}

	open() {
		this.opened = true;
		document.body.classList.add( this.bodyClass );
		this.dialog.showModal();

		localStorage.setItem( this.storageKey, Date.now() ); // timestamp (milliseconds)
	}

	close() {
		this.opened = false;
		this.dialog.classList.add( this.outClass );
	}

}

export default new LeadGenModal( document.querySelector( '#cicero-lead-gen' ) );
